module.exports = __webpack_public_path__ + "img/icon_job_05.6c52e240.svg";